import useAuth from "./useAuth";
import { KeycloakTokenParsed } from "keycloak-js";

/**
 * Generic RBAC hook that checks if the authenticated user has a specific app role.
 *
 * The role must appear under resource_access.app.roles in the Keycloak token.
 * Reads from the reactive `tokenParsed` store value so that role changes
 * are picked up after token refresh.
 *
 * @param role - The role name to check for
 * @returns boolean - true if user has the role, false otherwise
 */
export const useHasAppRole = (role: string) => {
  const { authenticated, tokenParsed } = useAuth();

  if (!authenticated || !tokenParsed) return false;

  const roles =
    (tokenParsed as KeycloakTokenParsed).resource_access?.app?.roles ?? [];
  return roles.includes(role);
};
